<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>
                            <v-card-title>
                                    Attribuer des produits à une pharmacie
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <v-form ref="form" v-model="valid" :lazy-validation="lazy" style="padding-bottom: 2%;">



                                <v-col cols="12" sm="12" md="12">
                                    <v-col class="d-flex" cols="12" sm="12">

                                        <v-autocomplete
                                                v-if="user.type_compte!=='pharmacie'"
                                                :rules="pharmaRules"
                                                v-model="editedItem.pharma"
                                                :loading="loading"
                                                :items="itemautos"
                                                item-text="nom"
                                                :search-input.sync="searchauto"
                                                cache-items
                                                flat
                                                hide-no-data
                                                hide-details
                                                clearable
                                                return-object
                                                label="Pharmacie"
                                                placeholder="Choisissez la pharmacie"

                                        >
                                        </v-autocomplete>
                                        <div  v-if="user.type_compte==='pharmacie'" class="ml-2"
                                             style="font-size: 12pt;text-align: center;
                            font-weight: bold">

                                            <v-chip v-if="user.relation!=null"  >{{ user.relation.nom }}</v-chip>
                                        </div>
                                    </v-col>
                                    <v-radio-group v-model="editedItem.action" row >
                                        <v-radio label="Tous les produits" value="tous"></v-radio>
                                        <v-radio label="Faire des choix" value="select"></v-radio>
                                    </v-radio-group>
                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-autocomplete
                                                v-if="editedItem.action=='select'"
                                                v-model="editedItem.prods"
                                                :items="produits"
                                                dense
                                                chips
                                                small-chips
                                                item-text="denomination"
                                                item-value="_id"
                                                label="Les produits"
                                                placeholder="Choisissez le / les produit(s)"
                                                multiple
                                                return-object
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                                :rules="qteRules"
                                                clearable
                                                v-model="editedItem.qte"
                                                label="Quantité par défaut"
                                                placeholder="ex : 25"></v-text-field>
                                        <span style="color: red" class="error-box"
                                              v-show="errors.qte">{{errors.qte}}</span>

                                    </v-col>

                                </v-col>

                                <div class="col-12" style="text-align: right">
                                    <v-btn @click="save" :disabled="(!valid)" color="success" style="margin-left: 3%"> Lancer maintenant
                                    </v-btn>
                                </div>

                            </v-form>

                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
   // import $ from "jquery";


    export default {
        name: "Produit",
        components: {},
        data() {
            return {

                itemautos: [],
                searchauto: null,
                submitting: false,
                overlay: false,
                errors: {},
                valid: true,
                lazy: false,
                user: JSON.parse(localStorage.getItem("user")),
                dialog: '',
                id: undefined,
                snackbar: false,
                textSnack: '',
                editedIndex: -1,
                items: [{'text':'Produits','value':"produit"},
                    {'text':'Categorie','value':"cat"},
                    {'text':'Tier','value':"tier"},
                    {'text':'Pharmacie','value':"pharma"},
                    ],
                editedItem: {
                    pharma: '',
                    prods: '',
                    action: 'tous',
                    qte: 10,

                },
                defaultItem: {
                    pharma: '',
                    prods: '',
                    qte: 10,
                }
                ,
                pharmaRules: [
                    v => !!v || 'Pharmacie requise',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ] ,
                qteRules: [
                    v => !!v || 'Pharmacie requise',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ]
            }
        }
        ,
        computed: {
            ...mapState('pharmacies/', ['pharmacies']),
            ...mapState('produits/', ['produits']),
        }
        ,
        mounted() {
        window.scrollTo(0,0);
            this.$store.dispatch('pharmacies/getPharmacie').then(response => {
                window.console.log('pharmacies', response)
            });
            this.$store.dispatch('produits/getProduits').then(response => {
                window.console.log('produits', response)

            });

        }
        ,
        watch: {
            searchauto(val) {
                val && val != this.editedItem.produit && this.querySelections(val)
            },
            loadProduct(){
                if (this.produits.length>0){
                   return false;
                }
                return true;
            }
        }
        ,
        methods: {
            initialize() {

            },
            querySelections(v) {
                this.loading = true
                // Simulated ajax query
                setTimeout(() => {
                    this.itemautos = this.pharmacies.filter(e => {
                        return (e.nom || '').toLowerCase().includes((v || '').toLowerCase())
                    });
                    this.loading = false
                }, 500);

            },
            save() {

              //  console.log(this.editedItem);

                this.overlay = true;
                if (this.editedItem.action!=='tous'){
                    if (this.editedItem.prods.length===0){
                        this.overlay = false;
                        this.snackbar = true;
                        this.textSnack = "Aucun produit n'a été choisit";
                        return;
                    }
                }
                console.log(this.editedItem);
                let data = new FormData();
                data.append("prods", JSON.stringify(this.editedItem.prods));
                if (this.user.type_compte==="pharmacie")
                {
                    data.append("pharma", this.user.relation._id);

                }else{
                    data.append("pharma", this.editedItem.pharma._id);

                }
                data.append("user", this.user._id);
                data.append("action", this.editedItem.action);
                data.append("qte", this.editedItem.qte);
                let mineroute = "uploads/setAttribution";

                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.overlay = false;
                    if (response.data.error) {
                            this.errors.operation = response.data.message;
                    } else {

                        this.reset();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>